import cx from "classnames";
import { Link } from "react-router-dom";
import { Wrapper } from "../styled/styled-components";
import { Context, IContext } from "../../context/ContextApp";
import { useContext } from "react";
import Icon from "../Icon/icon";
import MinusIcon from "../../assets/minusIcon";
import PlusIcon from "../../assets/plus";
import ExternalLink from "../../assets/externalLink";
import { CATEGORIES, webDataLinks } from "./data";

interface Props {
  webstoreExpanded: boolean;
  currentCategory: string;
  setCurrentCategory: React.Dispatch<React.SetStateAction<string>>;
  setWebstoreExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

const WebstoreMenu = ({
  webstoreExpanded,
  currentCategory,
  setCurrentCategory,
  setWebstoreExpanded,
}: Props) => {
  const { appBranch }: IContext = useContext(Context);
  const webstoreMenuLinks = CATEGORIES;

  const returnLinks = () =>
    webstoreMenuLinks.map((item, index) => (
      <Link
        key={index}
        className={cx({
          selected: webstoreExpanded && currentCategory === item.category,
          icons: true,
        })}
        to={item.route}
        onClick={() => {
          setCurrentCategory(item.category);
        }}
      >
        <Wrapper style={{ width: "15%" }}>
          <Icon name={item.icon} />
        </Wrapper>
        {item.title}
      </Link>
    ));

  const returnWebDataLinks = () => {
    return webDataLinks.map(
      (item, index) =>
        appBranch &&
        item.availableBranches.includes(appBranch) && (
          <a
            className="icons"
            href={item.links[appBranch]}
            key={index}
            target="_blank"
            rel="noreferrer"
          >
            <Wrapper style={{ width: "15%" }}>
              <Icon name={item.icon} />
            </Wrapper>
            {item.title}
            <div className="expand-icon" style={{ marginRight: "0.5rem" }}>
              <ExternalLink width={15} fill="white" />
            </div>
          </a>
        ),
    );
  };

  return (
    <div className="sidebar-menu">
      <div className="menu-label" onClick={() => setWebstoreExpanded(!webstoreExpanded)}>
        Webstore
        <div className="expand-icon">
          {webstoreExpanded ? (
            <MinusIcon width={10} fill="white" />
          ) : (
            <PlusIcon width={10} fill="white" />
          )}
        </div>
      </div>
      {webstoreExpanded && (
        <div className="sub-menu">
          {returnLinks()}
          {returnWebDataLinks()}
        </div>
      )}
    </div>
  );
};

export default WebstoreMenu;
